const uber_states = [
    { ORDERSTATECODE: "OFFERED", ORDERSTATE: "Offered" },
    { ORDERSTATECODE: "ACCEPTED", ORDERSTATE: "Accepted" },
    { ORDERSTATECODE: "HANDED_OFF", ORDERSTATE: "Handed Off" },
    { ORDERSTATECODE: "SUCCEEDED", ORDERSTATE: "Succeeded" },
    { ORDERSTATECODE: "FAILED", ORDERSTATE: "Failed" },
    { ORDERSTATECODE: "UNKNOWN", ORDERSTATE: "Unknown" },
  ];
  export default uber_states;


 export const uber_orders =[ {
    "data": [
      {
        "order": {
          "id": "bd1ed236-ee79-11ed-a05b-0242ac12A003",
          "display_id": "2A003",
          "external_id": "UBER_EATS_ORDER_1",
          "state": "Offered",
          "status": "SCHEDULED",
          "preparation_status": "PREPARING",
          "ordering_platform": "UBER_EATS",
          "fulfillment_type": "DELIVERY_BY_UBER",
          "scheduled_order_target_delivery_time_range": {
            "start_time": "2016-09-01T10:11:12.123456-0500",
            "end_time": "2016-09-01T10:11:12.123456-0500"
          },
          "store": {
            "id": "bd1ed236-ee79-11ed-a05b-0242ac120003",
            "name": "Uber's Pizza Palace",
            "partner_identifiers": [
              {
                "id": "store1",
                "type": "MERCHANT_STORE_ID"
              }
            ]
          },
          "customers": [
            {
              "id": "9ae8779e-1cd7-5322-86b6-d7955afd051b",
              "name": {
                "display_name": "John Doe",
                "first_name": "John",
                "last_name": "Doe"
              },
              "order_history": {
                "past_order_count": 9
              },
              "contact": {
                "phone": {
                  "number": "+94-72-265-8712",
                  "pin_code": "888 52 337",
                  "country_iso2": "LK"
                }
              },
              "is_primary_customer": true,
              "tax_profile": {
                "tax_ids": "123abc",
                "tax_id_type": "NIF",
                "customer_full_name": "John Smith",
                "email": "john@smith.com",
                "legal_entity_name": "John Smith, LLC",
                "billing_address": "1 Broadway, New York, NY 11109",
                "country": "United States",
                "encrypted_tax_id": {
                  "key": "string",
                  "cipher_text": "string"
                }
              },
              "can_respond_to_fulfillment_issues": true
            }
          ],
          "deliveries": [
            {
              "id": "1676a555-1a6f-4d49-be91-c9bb8f94af49",
              "delivery_partner": {
                "id": "string",
                "name": "John Smith",
                "vehicle": {
                  "type": "CAR",
                  "make": "Honda",
                  "model": "Accord",
                  "color": "red",
                  "license_plate": "T124224",
                  "is_autonomous": true,
                  "handoff_instructions": "string",
                  "passcode": "abc123"
                },
                "picture_url": "string",
                "contact": {
                  "phone": {
                    "number": "+1-800-999-9999",
                    "pin_code": "888 52 337",
                    "country_iso2": "US"
                  }
                },
                "current_location": {
                  "latitude": 38.8951,
                  "longitude": -77.0364
                }
              },
              "status": "SCHEDULED",
              "location": {
                "type": "GOOGLE_PLACE",
                "id": "23119fca-ec44-5c6d-8dc9-2ac8cdde310d",
                "street_address_line_one": "175 Greenwich St",
                "street_address_line_two": "44-023",
                "latitude": "38.8951",
                "longitude": "-77.0364",
                "unit_number": 1,
                "business_name": "Uber Technologies Inc.",
                "city": "NY",
                "country": "US",
                "postal_code": "10007",
                "location_type_value": "asf-123ijfdishs_",
                "client_provided_street_address_line_one": "string"
              },
              "estimated_pick_up_time": "2016-09-01T10:11:12.123456-0500",
              "interaction_type": "DOOR_TO_DOOR",
              "delivery_partner_marked_not_ready_time": "2016-09-01T10:11:12.123456-0500",
              "instructions": "Please do not ring doorbell."
            }
          ],
          "carts": [
            {
              "id": "string",
              "items": [
                {
                  "id": "pizza_cheese",
                  "cart_item_id": "c751e24c-ee7a-11ed-a05b-0242ac120003",
                  "customer_id": "092400ec-ee7b-11ed-a05b-0242ac120003",
                  "title": "Cheese Pizza 18",
                  "external_data": "chz_piz_18",
                  "quantity": {
                    "amount": 1,
                    "in_sellable_unit": {
                      "measurement_unit": {}
                    },
                    "in_priceable_unit": {
                      "measurement_unit": {}
                    }
                  },
                  "default_quantity": {
                    "amount": 1,
                    "unit": "PIECE"
                  },
                  "customer_requests": {
                    "allergy": {
                      "allergens": []
                    },
                    "special_instructions": "Add extra sauce"
                  },
                  "selected_modifier_groups": [
                    {
                      "selected_items": [],
                      "removed_items": []
                    }
                  ],
                  "picture_url": "string",
                  "fulfillment_action": {
                    "action_type": "REPLACE_FOR_ME",
                    "item_substitutes": [
                      null
                    ]
                  }
                },
                {
                    "id": "chocolate_donut",
                    "cart_item_id": "c751e24c-ee7a-11ed-a05b-0242ac120003",
                    "customer_id": "092400ec-ee7b-11ed-a05b-0242ac120003",
                    "title": "Chocolate Donut S",
                    "external_data": "chz_piz_18",
                    "quantity": {
                      "amount": 1,
                      "in_sellable_unit": {
                        "measurement_unit": {}
                      },
                      "in_priceable_unit": {
                        "measurement_unit": {}
                      }
                    },
                    "default_quantity": {
                      "amount": 1,
                      "unit": "PIECE"
                    },
                    "customer_requests": {
                      "allergy": {
                        "allergens": []
                      },
                      "special_instructions": "Add new ones"
                    },
                    "selected_modifier_groups": [
                      {
                        "selected_items": [],
                        "removed_items": []
                      }
                    ],
                    "picture_url": "string",
                    "fulfillment_action": {
                      "action_type": "REPLACE_FOR_ME",
                      "item_substitutes": [
                        null
                      ]
                    }
                  },
                  {
                    "id": "rolls",
                    "cart_item_id": "c751e24c-ee7a-11ed-a05b-0242ac120003",
                    "customer_id": "092400ec-ee7b-11ed-a05b-0242ac120003",
                    "title": "Cheese rolls",
                    "external_data": "chz_piz_18",
                    "quantity": {
                      "amount": 1,
                      "in_sellable_unit": {
                        "measurement_unit": {}
                      },
                      "in_priceable_unit": {
                        "measurement_unit": {}
                      }
                    },
                    "default_quantity": {
                      "amount": 1,
                      "unit": "PIECE"
                    },
                    "customer_requests": {
                      "allergy": {
                        "allergens": []
                      },
                      "special_instructions": "Need it fresh and hot"
                    },
                    "selected_modifier_groups": [
                      {
                        "selected_items": [],
                        "removed_items": []
                      }
                    ],
                    "picture_url": "string",
                    "fulfillment_action": {
                      "action_type": "REPLACE_FOR_ME",
                      "item_substitutes": [
                        null
                      ]
                    }
                  }
              ],
              "fulfillment_issues": [
                {
                  "issue_type": "OUT_OF_ITEM",
                  "action_type": "ASK_CUSTOMER",
                  "root_item": {
                    "id": "pizza_cheese",
                    "cart_item_id": "c751e24c-ee7a-11ed-a05b-0242ac120003",
                    "customer_id": "092400ec-ee7b-11ed-a05b-0242ac120003",
                    "title": "Cheese Pizza 18",
                    "quantity": {},
                    "picture_url": "string"
                  },
                  "item_availability": {
                    "items_requested": {},
                    "items_available": {
                      "in_sellable_unit": {},
                      "in_priceable_unit": {}
                    }
                  },
                  "item_substitute": {
                    "id": "pizza_cheese",
                    "quantity": {}
                  },
                  "suspend_until": "2016-09-01T10:11:12.12-0500",
                  "store_response": "The store ran out of stock.",
                  "customer_ack_type": "ACK_DISABLED"
                }
              ],
              "special_instructions": "Please add extra sauce.",
              "include_single_use_items": true,
              "revision_id": "string",
              "restricted_items": {
                "alcohol": {
                  "contain_alcoholic_item": false
                },
                "tobacco": {
                  "contain_tobacco_product": true
                }
              }
            }
          ],
          "payment": {
            "payment_detail": {
              "order_total": {
                "display_amount": "string",
                "net": {
                  "amount_e5": 2250000,
                  "currency_code": "LKR",
                  "formatted": "LKR 22.50"
                },
                "tax": {
                  "amount_e5": 0,
                  "currency_code": "LKR",
                  "formatted": "LKR 0.0"
                },
                "gross": {
                  "amount_e5": 2250000,
                  "currency_code": "LKR",
                  "formatted": "LKR 22.50"
                },
                "is_tax_inclusive": true
              },
              "item_charges": {
                "total": {
                  "display_amount": "string",
                  "net": {
                    "amount_e5": 750000,
                    "currency_code": "LKR",
                    "formatted": "LKR 7.50"
                  },
                  "tax": {
                    "amount_e5": 0,
                    "currency_code": "LKR",
                    "formatted": "LKR 0"
                  },
                  "gross": {
                    "amount_e5": 750000,
                    "currency_code": "LKR",
                    "formatted": "LKR 7.50"
                  },
                  "is_tax_inclusive": true
                },
                "subtotal_including_promos": {
                  "display_amount": "string",
                  "net": {
                    "amount_e5": 750000,
                    "currency_code": "LKR",
                    "formatted": "LKR 7.50"
                  },
                  "tax": {
                    "amount_e5": 0,
                    "currency_code": "LKR",
                    "formatted": "LKR 0"
                  },
                  "gross": {
                    "amount_e5": 750000,
                    "currency_code": "LKR",
                    "formatted": "LKR 7.50"
                  },
                  "is_tax_inclusive": true
                },
                "price_breakdown": [
                  {
                    "cart_item_id": "c751e24c-ee7a-11ed-a05b-0242ac120003",
                    "price_type": "OPTION",
                    "quantity": {
                      "in_sellable_unit": {},
                      "in_priceable_unit": {}
                    },
                    "total": {
                      "net": {},
                      "tax": {},
                      "gross": {},
                      "is_tax_inclusive": {}
                    },
                    "discount": {
                      "total": {},
                      "quantity": {}
                    },
                    "unit": {
                      "net": {},
                      "tax": {},
                      "gross": {}
                    }
                  }
                ]
              },
              "fees": {
                "total": {
                  "display_amount": "string",
                  "net": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "tax": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "gross": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "is_tax_inclusive": true
                },
                "details": [
                  {
                    "id": "SMALL_ORDER_FEE",
                    "amount": {
                      "net": {},
                      "tax": {},
                      "gross": {}
                    }
                  }
                ]
              },
              "tips": {
                "total": {
                  "display_amount": "string",
                  "net": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "tax": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "gross": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "is_tax_inclusive": true
                }
              },
              "promotions": {
                "total": {
                  "display_amount": "string",
                  "net": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "tax": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "gross": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "is_tax_inclusive": true
                },
                "details": [
                  {
                    "external_promotion_id": "string",
                    "type": "string",
                    "discount_value": "string",
                    "discount_percentage": "string",
                    "discount_delivery_fee_value": 100,
                    "discount_items": [
                      {}
                    ]
                  }
                ],
                "order_total_excluding_promos": {
                  "display_amount": "string",
                  "net": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "tax": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "gross": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "is_tax_inclusive": true
                }
              },
              "adjustment": {
                "total": {
                  "display_amount": "string",
                  "net": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "tax": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "gross": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "is_tax_inclusive": true
                },
                "details": {
                  "amount": {
                    "display_amount": "string",
                    "net": {},
                    "tax": {},
                    "gross": {},
                    "is_tax_inclusive": true
                  },
                  "reason": "Customer requested extra meat on salad bowl."
                }
              },
              "currency_code": "string",
              "cash_amount_due": {
                "display_amount": "string",
                "net": {
                  "amount_e5": 750000,
                  "currency_code": "USD",
                  "formatted": "$7.50"
                },
                "tax": {
                  "amount_e5": 750000,
                  "currency_code": "USD",
                  "formatted": "$7.50"
                },
                "gross": {
                  "amount_e5": 750000,
                  "currency_code": "USD",
                  "formatted": "$7.50"
                },
                "is_tax_inclusive": true
              }
            },
            "tax_reporting": {
              "breakdown": {
                "items": [
                  {
                    "instance_id": "string",
                    "description": "DELIVERY_FEE",
                    "gross_amount": {},
                    "net_amount": {}
                  }
                ],
                "fees": [
                  {
                    "instance_id": "string",
                    "description": "DELIVERY_FEE",
                    "gross_amount": {},
                    "net_amount": {}
                  }
                ],
                "promotions": [
                  {
                    "instance_id": "string",
                    "description": "DELIVERY_FEE",
                    "gross_amount": {},
                    "net_amount": {}
                  }
                ]
              },
              "origin": {
                "id": "string",
                "country_iso2": "string",
                "postal_code": "string"
              },
              "destination": {
                "id": "string",
                "country_iso2": "string",
                "postal_code": "string"
              },
              "remittance_info": [
                {
                  "entity": "UBER",
                  "type": "SUBTOTAL",
                  "amount": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  }
                }
              ]
            }
          },
          "is_order_accuracy_risk": true,
          "store_instructions": "Need tissues",
          "preparation_time": {
            "ready_for_pickup_time_secs": 500,
            "source": "PREDICTED_BY_UBER",
            "ready_for_pickup_time": "2016-09-01T10:11:12.123456-0500"
          },
          "completed_time": "2016-09-01T10:11:12.123456-0500",
          "eligible_actions": {
            "adjust_ready_for_pickup_time": {
              "is_eligible": true,
              "reason": "string"
            },
            "mark_out_of_item": {
              "is_eligible": true,
              "reason": "string"
            },
            "cancel": {
              "is_eligible": true,
              "reason": "string"
            },
            "mark_cannot_fulfill": {
              "is_eligible": true,
              "reason": "string"
            },
            "adjust_etd_time": {
              "is_eligible": true,
              "reason": "string"
            },
            "customer_request_etd": {
              "is_eligible": true,
              "reason": "string"
            }
          },
          "failure_info": {
            "reason": "POS_DENIED",
            "failure_attributed_to_party": "UNKNOWN",
            "will_merchant_be_paid": true,
            "description": "string"
          },
          "created_time": "2016-09-01T10:11:12.123456-0500",
          "has_membership_pass": true,
          "retailer_loyalty_info": {
            "loyalty_number": 1240822
          },
          "order_tracking_metadata": {
            "url": "https://earn.sng.link/A3ir4p/eh3s?_dl=uberdriver://byoc-mode?code=fedbab8e-cbce-484e-9d90-067489017968&_smtype=3&pcn=byoc_ot&$deeplink_path=uberdriver://byoc-mode?code=fedbab8e-cbce-484e-9dh0-067489917961"
          }
        }
      }
    ],
    "pagination_data": {
      "next_page_token": "string",
      "page_size": 0
    }
  },
  {
    "data": [
      {
        "order": {
          "id": "bd1ed236-ee79-11ed-a05b-0242ac12A003",
          "display_id": "2A003",
          "external_id": "UBER_EATS_ORDER_1",
          "state": "Accepted",
          "status": "SCHEDULED",
          "preparation_status": "PREPARING",
          "ordering_platform": "UBER_EATS",
          "fulfillment_type": "DELIVERY_BY_UBER",
          "scheduled_order_target_delivery_time_range": {
            "start_time": "2016-09-01T10:11:12.123456-0500",
            "end_time": "2016-09-01T10:11:12.123456-0500"
          },
          "store": {
            "id": "bd1ed236-ee79-11ed-a05b-0242ac120003",
            "name": "Uber's Pizza Palace",
            "partner_identifiers": [
              {
                "id": "store1",
                "type": "MERCHANT_STORE_ID"
              }
            ]
          },
          "customers": [
            {
              "id": "9ae8779e-1cd7-5322-86b6-d7955afd051b",
              "name": {
                "display_name": "Uber L",
                "first_name": "Uber",
                "last_name": "L"
              },
              "order_history": {
                "past_order_count": 3
              },
              "contact": {
                "phone": {
                  "number": "+1-800-999-9999",
                  "pin_code": "888 52 337",
                  "country_iso2": "US"
                }
              },
              "is_primary_customer": true,
              "tax_profile": {
                "tax_ids": "123abc",
                "tax_id_type": "NIF",
                "customer_full_name": "John Smith",
                "email": "john@smith.com",
                "legal_entity_name": "John Smith, LLC",
                "billing_address": "1 Broadway, New York, NY 11109",
                "country": "United States",
                "encrypted_tax_id": {
                  "key": "string",
                  "cipher_text": "string"
                }
              },
              "can_respond_to_fulfillment_issues": true
            }
          ],
          "deliveries": [
            {
              "id": "1676a555-1a6f-4d49-be91-c9bb8f94af49",
              "delivery_partner": {
                "id": "string",
                "name": "John Smith",
                "vehicle": {
                  "type": "CAR",
                  "make": "Honda",
                  "model": "Accord",
                  "color": "red",
                  "license_plate": "T124224",
                  "is_autonomous": true,
                  "handoff_instructions": "string",
                  "passcode": "abc123"
                },
                "picture_url": "string",
                "contact": {
                  "phone": {
                    "number": "+1-800-999-9999",
                    "pin_code": "888 52 337",
                    "country_iso2": "US"
                  }
                },
                "current_location": {
                  "latitude": 38.8951,
                  "longitude": -77.0364
                }
              },
              "status": "SCHEDULED",
              "location": {
                "type": "GOOGLE_PLACE",
                "id": "23119fca-ec44-5c6d-8dc9-2ac8cdde310d",
                "street_address_line_one": "175 Greenwich St",
                "street_address_line_two": "44-023",
                "latitude": "38.8951",
                "longitude": "-77.0364",
                "unit_number": 1,
                "business_name": "Uber Technologies Inc.",
                "city": "NY",
                "country": "US",
                "postal_code": "10007",
                "location_type_value": "asf-123ijfdishs_",
                "client_provided_street_address_line_one": "string"
              },
              "estimated_pick_up_time": "2016-09-01T10:11:12.123456-0500",
              "interaction_type": "DOOR_TO_DOOR",
              "delivery_partner_marked_not_ready_time": "2016-09-01T10:11:12.123456-0500",
              "instructions": "Please do not ring doorbell."
            }
          ],
          "carts": [
            {
              "id": "string",
              "items": [
                {
                  "id": "pizza_cheese",
                  "cart_item_id": "c751e24c-ee7a-11ed-a05b-0242ac120003",
                  "customer_id": "092400ec-ee7b-11ed-a05b-0242ac120003",
                  "title": "Cheese Pizza 18",
                  "external_data": "chz_piz_18",
                  "quantity": {
                    "amount": 1,
                    "in_sellable_unit": {
                      "measurement_unit": {}
                    },
                    "in_priceable_unit": {
                      "measurement_unit": {}
                    }
                  },
                  "default_quantity": {
                    "amount": 1,
                    "unit": "PIECE"
                  },
                  "customer_requests": {
                    "allergy": {
                      "allergens": []
                    },
                    "special_instructions": "Add extra sauce"
                  },
                  "selected_modifier_groups": [
                    {
                      "selected_items": [],
                      "removed_items": []
                    }
                  ],
                  "picture_url": "string",
                  "fulfillment_action": {
                    "action_type": "REPLACE_FOR_ME",
                    "item_substitutes": [
                      null
                    ]
                  }
                }
              ],
              "fulfillment_issues": [
                {
                  "issue_type": "OUT_OF_ITEM",
                  "action_type": "ASK_CUSTOMER",
                  "root_item": {
                    "id": "pizza_cheese",
                    "cart_item_id": "c751e24c-ee7a-11ed-a05b-0242ac120003",
                    "customer_id": "092400ec-ee7b-11ed-a05b-0242ac120003",
                    "title": "Cheese Pizza 18",
                    "quantity": {},
                    "picture_url": "string"
                  },
                  "item_availability": {
                    "items_requested": {},
                    "items_available": {
                      "in_sellable_unit": {},
                      "in_priceable_unit": {}
                    }
                  },
                  "item_substitute": {
                    "id": "pizza_cheese",
                    "quantity": {}
                  },
                  "suspend_until": "2016-09-01T10:11:12.12-0500",
                  "store_response": "The store ran out of stock.",
                  "customer_ack_type": "ACK_DISABLED"
                }
              ],
              "special_instructions": "Please add extra sauce.",
              "include_single_use_items": true,
              "revision_id": "string",
              "restricted_items": {
                "alcohol": {
                  "contain_alcoholic_item": false
                },
                "tobacco": {
                  "contain_tobacco_product": true
                }
              }
            }
          ],
          "payment": {
            "payment_detail": {
              "order_total": {
                "display_amount": "string",
                "net": {
                  "amount_e5": 750000,
                  "currency_code": "LKR",
                  "formatted": "LKR 7.50"
                },
                "tax": {
                  "amount_e5": 0,
                  "currency_code": "LKR",
                  "formatted": "LKR 0.0"
                },
                "gross": {
                  "amount_e5": 750000,
                  "currency_code": "LKR",
                  "formatted": "LKR 7.50"
                },
                "is_tax_inclusive": true
              },
              "item_charges": {
                "total": {
                  "display_amount": "string",
                  "net": {
                    "amount_e5": 750000,
                    "currency_code": "LKR",
                    "formatted": "LKR 7.50"
                  },
                  "tax": {
                    "amount_e5": 0,
                    "currency_code": "LKR",
                    "formatted": "LKR 0"
                  },
                  "gross": {
                    "amount_e5": 750000,
                    "currency_code": "LKR",
                    "formatted": "LKR 7.50"
                  },
                  "is_tax_inclusive": true
                },
                "subtotal_including_promos": {
                  "display_amount": "string",
                  "net": {
                    "amount_e5": 750000,
                    "currency_code": "LKR",
                    "formatted": "LKR 7.50"
                  },
                  "tax": {
                    "amount_e5": 0,
                    "currency_code": "LKR",
                    "formatted": "LKR 0"
                  },
                  "gross": {
                    "amount_e5": 750000,
                    "currency_code": "LKR",
                    "formatted": "LKR 7.50"
                  },
                  "is_tax_inclusive": true
                },
                "price_breakdown": [
                  {
                    "cart_item_id": "c751e24c-ee7a-11ed-a05b-0242ac120003",
                    "price_type": "OPTION",
                    "quantity": {
                      "in_sellable_unit": {},
                      "in_priceable_unit": {}
                    },
                    "total": {
                      "net": {},
                      "tax": {},
                      "gross": {},
                      "is_tax_inclusive": {}
                    },
                    "discount": {
                      "total": {},
                      "quantity": {}
                    },
                    "unit": {
                      "net": {},
                      "tax": {},
                      "gross": {}
                    }
                  }
                ]
              },
              "fees": {
                "total": {
                  "display_amount": "string",
                  "net": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "tax": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "gross": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "is_tax_inclusive": true
                },
                "details": [
                  {
                    "id": "SMALL_ORDER_FEE",
                    "amount": {
                      "net": {},
                      "tax": {},
                      "gross": {}
                    }
                  }
                ]
              },
              "tips": {
                "total": {
                  "display_amount": "string",
                  "net": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "tax": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "gross": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "is_tax_inclusive": true
                }
              },
              "promotions": {
                "total": {
                  "display_amount": "string",
                  "net": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "tax": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "gross": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "is_tax_inclusive": true
                },
                "details": [
                  {
                    "external_promotion_id": "string",
                    "type": "string",
                    "discount_value": "string",
                    "discount_percentage": "string",
                    "discount_delivery_fee_value": 100,
                    "discount_items": [
                      {}
                    ]
                  }
                ],
                "order_total_excluding_promos": {
                  "display_amount": "string",
                  "net": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "tax": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "gross": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "is_tax_inclusive": true
                }
              },
              "adjustment": {
                "total": {
                  "display_amount": "string",
                  "net": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "tax": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "gross": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "is_tax_inclusive": true
                },
                "details": {
                  "amount": {
                    "display_amount": "string",
                    "net": {},
                    "tax": {},
                    "gross": {},
                    "is_tax_inclusive": true
                  },
                  "reason": "Customer requested extra meat on salad bowl."
                }
              },
              "currency_code": "string",
              "cash_amount_due": {
                "display_amount": "string",
                "net": {
                  "amount_e5": 750000,
                  "currency_code": "USD",
                  "formatted": "$7.50"
                },
                "tax": {
                  "amount_e5": 750000,
                  "currency_code": "USD",
                  "formatted": "$7.50"
                },
                "gross": {
                  "amount_e5": 750000,
                  "currency_code": "USD",
                  "formatted": "$7.50"
                },
                "is_tax_inclusive": true
              }
            },
            "tax_reporting": {
              "breakdown": {
                "items": [
                  {
                    "instance_id": "string",
                    "description": "DELIVERY_FEE",
                    "gross_amount": {},
                    "net_amount": {}
                  }
                ],
                "fees": [
                  {
                    "instance_id": "string",
                    "description": "DELIVERY_FEE",
                    "gross_amount": {},
                    "net_amount": {}
                  }
                ],
                "promotions": [
                  {
                    "instance_id": "string",
                    "description": "DELIVERY_FEE",
                    "gross_amount": {},
                    "net_amount": {}
                  }
                ]
              },
              "origin": {
                "id": "string",
                "country_iso2": "string",
                "postal_code": "string"
              },
              "destination": {
                "id": "string",
                "country_iso2": "string",
                "postal_code": "string"
              },
              "remittance_info": [
                {
                  "entity": "UBER",
                  "type": "SUBTOTAL",
                  "amount": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  }
                }
              ]
            }
          },
          "is_order_accuracy_risk": true,
          "store_instructions": "add ketchup",
          "preparation_time": {
            "ready_for_pickup_time_secs": 500,
            "source": "PREDICTED_BY_UBER",
            "ready_for_pickup_time": "2016-09-01T10:11:12.123456-0500"
          },
          "completed_time": "2016-09-01T10:11:12.123456-0500",
          "eligible_actions": {
            "adjust_ready_for_pickup_time": {
              "is_eligible": true,
              "reason": "string"
            },
            "mark_out_of_item": {
              "is_eligible": true,
              "reason": "string"
            },
            "cancel": {
              "is_eligible": true,
              "reason": "string"
            },
            "mark_cannot_fulfill": {
              "is_eligible": true,
              "reason": "string"
            },
            "adjust_etd_time": {
              "is_eligible": true,
              "reason": "string"
            },
            "customer_request_etd": {
              "is_eligible": true,
              "reason": "string"
            }
          },
          "failure_info": {
            "reason": "POS_DENIED",
            "failure_attributed_to_party": "UNKNOWN",
            "will_merchant_be_paid": true,
            "description": "string"
          },
          "created_time": "2016-09-01T10:11:12.123456-0500",
          "has_membership_pass": true,
          "retailer_loyalty_info": {
            "loyalty_number": 1240822
          },
          "order_tracking_metadata": {
            "url": "https://earn.sng.link/A3ir4p/eh3s?_dl=uberdriver://byoc-mode?code=fedbab8e-cbce-484e-9d90-067489017968&_smtype=3&pcn=byoc_ot&$deeplink_path=uberdriver://byoc-mode?code=fedbab8e-cbce-484e-9dh0-067489917961"
          }
        }
      }
    ],
    "pagination_data": {
      "next_page_token": "string",
      "page_size": 0
    }
  },
  {
    "data": [
      {
        "order": {
          "id": "bd1ed236-ee79-11ed-a05b-0242ac12A003",
          "display_id": "2A003",
          "external_id": "UBER_EATS_ORDER_1",
          "state": "Accepted",
          "status": "SCHEDULED",
          "preparation_status": "PREPARING",
          "ordering_platform": "UBER_EATS",
          "fulfillment_type": "DELIVERY_BY_UBER",
          "scheduled_order_target_delivery_time_range": {
            "start_time": "2016-09-01T10:11:12.123456-0500",
            "end_time": "2016-09-01T10:11:12.123456-0500"
          },
          "store": {
            "id": "bd1ed236-ee79-11ed-a05b-0242ac120003",
            "name": "Uber's Pizza Palace",
            "partner_identifiers": [
              {
                "id": "store1",
                "type": "MERCHANT_STORE_ID"
              }
            ]
          },
          "customers": [
            {
              "id": "9ae8779e-1cd7-5322-86b6-d7955afd051b",
              "name": {
                "display_name": "Uber L",
                "first_name": "Uber",
                "last_name": "L"
              },
              "order_history": {
                "past_order_count": 3
              },
              "contact": {
                "phone": {
                  "number": "+1-800-999-9999",
                  "pin_code": "888 52 337",
                  "country_iso2": "US"
                }
              },
              "is_primary_customer": true,
              "tax_profile": {
                "tax_ids": "123abc",
                "tax_id_type": "NIF",
                "customer_full_name": "John Smith",
                "email": "john@smith.com",
                "legal_entity_name": "John Smith, LLC",
                "billing_address": "1 Broadway, New York, NY 11109",
                "country": "United States",
                "encrypted_tax_id": {
                  "key": "string",
                  "cipher_text": "string"
                }
              },
              "can_respond_to_fulfillment_issues": true
            }
          ],
          "deliveries": [
            {
              "id": "1676a555-1a6f-4d49-be91-c9bb8f94af49",
              "delivery_partner": {
                "id": "string",
                "name": "John Smith",
                "vehicle": {
                  "type": "CAR",
                  "make": "Honda",
                  "model": "Accord",
                  "color": "red",
                  "license_plate": "T124224",
                  "is_autonomous": true,
                  "handoff_instructions": "string",
                  "passcode": "abc123"
                },
                "picture_url": "string",
                "contact": {
                  "phone": {
                    "number": "+1-800-999-9999",
                    "pin_code": "888 52 337",
                    "country_iso2": "US"
                  }
                },
                "current_location": {
                  "latitude": 38.8951,
                  "longitude": -77.0364
                }
              },
              "status": "SCHEDULED",
              "location": {
                "type": "GOOGLE_PLACE",
                "id": "23119fca-ec44-5c6d-8dc9-2ac8cdde310d",
                "street_address_line_one": "175 Greenwich St",
                "street_address_line_two": "44-023",
                "latitude": "38.8951",
                "longitude": "-77.0364",
                "unit_number": 1,
                "business_name": "Uber Technologies Inc.",
                "city": "NY",
                "country": "US",
                "postal_code": "10007",
                "location_type_value": "asf-123ijfdishs_",
                "client_provided_street_address_line_one": "string"
              },
              "estimated_pick_up_time": "2016-09-01T10:11:12.123456-0500",
              "interaction_type": "DOOR_TO_DOOR",
              "delivery_partner_marked_not_ready_time": "2016-09-01T10:11:12.123456-0500",
              "instructions": "Please do not ring doorbell."
            }
          ],
          "carts": [
            {
              "id": "string",
              "items": [
                {
                  "id": "milk_shake",
                  "cart_item_id": "c751e24c-ee7a-11ed-a05b-0242ac120003",
                  "customer_id": "092400ec-ee7b-11ed-a05b-0242ac120003",
                  "title": "Milk Shake (Choc)",
                  "external_data": "chz_piz_18",
                  "quantity": {
                    "amount": 1,
                    "in_sellable_unit": {
                      "measurement_unit": {}
                    },
                    "in_priceable_unit": {
                      "measurement_unit": {}
                    }
                  },
                  "default_quantity": {
                    "amount": 1,
                    "unit": "PIECE"
                  },
                  "customer_requests": {
                    "allergy": {
                      "allergens": []
                    },
                    "special_instructions": "Add straws"
                  },
                  "selected_modifier_groups": [
                    {
                      "selected_items": [],
                      "removed_items": []
                    }
                  ],
                  "picture_url": "string",
                  "fulfillment_action": {
                    "action_type": "REPLACE_FOR_ME",
                    "item_substitutes": [
                      null
                    ]
                  }
                }
              ],
              "fulfillment_issues": [
                {
                  "issue_type": "OUT_OF_ITEM",
                  "action_type": "ASK_CUSTOMER",
                  "root_item": {
                    "id": "pizza_cheese",
                    "cart_item_id": "c751e24c-ee7a-11ed-a05b-0242ac120003",
                    "customer_id": "092400ec-ee7b-11ed-a05b-0242ac120003",
                    "title": "Cheese Pizza 18",
                    "quantity": {},
                    "picture_url": "string"
                  },
                  "item_availability": {
                    "items_requested": {},
                    "items_available": {
                      "in_sellable_unit": {},
                      "in_priceable_unit": {}
                    }
                  },
                  "item_substitute": {
                    "id": "pizza_cheese",
                    "quantity": {}
                  },
                  "suspend_until": "2016-09-01T10:11:12.12-0500",
                  "store_response": "The store ran out of stock.",
                  "customer_ack_type": "ACK_DISABLED"
                }
              ],
              "special_instructions": "Please add extra sauce.",
              "include_single_use_items": true,
              "revision_id": "string",
              "restricted_items": {
                "alcohol": {
                  "contain_alcoholic_item": false
                },
                "tobacco": {
                  "contain_tobacco_product": true
                }
              }
            }
          ],
          "payment": {
            "payment_detail": {
              "order_total": {
                "display_amount": "string",
                "net": {
                  "amount_e5": 850000,
                  "currency_code": "LKR",
                  "formatted": "LKR 8.50"
                },
                "tax": {
                  "amount_e5": 0,
                  "currency_code": "LKR",
                  "formatted": "LKR 0.0"
                },
                "gross": {
                  "amount_e5": 850000,
                  "currency_code": "LKR",
                  "formatted": "LKR 8.50"
                },
                "is_tax_inclusive": true
              },
              "item_charges": {
                "total": {
                  "display_amount": "string",
                  "net": {
                    "amount_e5": 750000,
                    "currency_code": "LKR",
                    "formatted": "LKR 7.50"
                  },
                  "tax": {
                    "amount_e5": 0,
                    "currency_code": "LKR",
                    "formatted": "LKR 0"
                  },
                  "gross": {
                    "amount_e5": 750000,
                    "currency_code": "LKR",
                    "formatted": "LKR 7.50"
                  },
                  "is_tax_inclusive": true
                },
                "subtotal_including_promos": {
                  "display_amount": "string",
                  "net": {
                    "amount_e5": 750000,
                    "currency_code": "LKR",
                    "formatted": "LKR 7.50"
                  },
                  "tax": {
                    "amount_e5": 0,
                    "currency_code": "LKR",
                    "formatted": "LKR 0"
                  },
                  "gross": {
                    "amount_e5": 750000,
                    "currency_code": "LKR",
                    "formatted": "LKR 7.50"
                  },
                  "is_tax_inclusive": true
                },
                "price_breakdown": [
                  {
                    "cart_item_id": "c751e24c-ee7a-11ed-a05b-0242ac120003",
                    "price_type": "OPTION",
                    "quantity": {
                      "in_sellable_unit": {},
                      "in_priceable_unit": {}
                    },
                    "total": {
                      "net": {},
                      "tax": {},
                      "gross": {},
                      "is_tax_inclusive": {}
                    },
                    "discount": {
                      "total": {},
                      "quantity": {}
                    },
                    "unit": {
                      "net": {},
                      "tax": {},
                      "gross": {}
                    }
                  }
                ]
              },
              "fees": {
                "total": {
                  "display_amount": "string",
                  "net": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "tax": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "gross": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "is_tax_inclusive": true
                },
                "details": [
                  {
                    "id": "SMALL_ORDER_FEE",
                    "amount": {
                      "net": {},
                      "tax": {},
                      "gross": {}
                    }
                  }
                ]
              },
              "tips": {
                "total": {
                  "display_amount": "string",
                  "net": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "tax": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "gross": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "is_tax_inclusive": true
                }
              },
              "promotions": {
                "total": {
                  "display_amount": "string",
                  "net": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "tax": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "gross": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "is_tax_inclusive": true
                },
                "details": [
                  {
                    "external_promotion_id": "string",
                    "type": "string",
                    "discount_value": "string",
                    "discount_percentage": "string",
                    "discount_delivery_fee_value": 100,
                    "discount_items": [
                      {}
                    ]
                  }
                ],
                "order_total_excluding_promos": {
                  "display_amount": "string",
                  "net": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "tax": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "gross": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "is_tax_inclusive": true
                }
              },
              "adjustment": {
                "total": {
                  "display_amount": "string",
                  "net": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "tax": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "gross": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "is_tax_inclusive": true
                },
                "details": {
                  "amount": {
                    "display_amount": "string",
                    "net": {},
                    "tax": {},
                    "gross": {},
                    "is_tax_inclusive": true
                  },
                  "reason": "Customer requested extra meat on salad bowl."
                }
              },
              "currency_code": "string",
              "cash_amount_due": {
                "display_amount": "string",
                "net": {
                  "amount_e5": 750000,
                  "currency_code": "USD",
                  "formatted": "$7.50"
                },
                "tax": {
                  "amount_e5": 750000,
                  "currency_code": "USD",
                  "formatted": "$7.50"
                },
                "gross": {
                  "amount_e5": 750000,
                  "currency_code": "USD",
                  "formatted": "$7.50"
                },
                "is_tax_inclusive": true
              }
            },
            "tax_reporting": {
              "breakdown": {
                "items": [
                  {
                    "instance_id": "string",
                    "description": "DELIVERY_FEE",
                    "gross_amount": {},
                    "net_amount": {}
                  }
                ],
                "fees": [
                  {
                    "instance_id": "string",
                    "description": "DELIVERY_FEE",
                    "gross_amount": {},
                    "net_amount": {}
                  }
                ],
                "promotions": [
                  {
                    "instance_id": "string",
                    "description": "DELIVERY_FEE",
                    "gross_amount": {},
                    "net_amount": {}
                  }
                ]
              },
              "origin": {
                "id": "string",
                "country_iso2": "string",
                "postal_code": "string"
              },
              "destination": {
                "id": "string",
                "country_iso2": "string",
                "postal_code": "string"
              },
              "remittance_info": [
                {
                  "entity": "UBER",
                  "type": "SUBTOTAL",
                  "amount": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  }
                }
              ]
            }
          },
          "is_order_accuracy_risk": true,
          "store_instructions": "Add straws",
          "preparation_time": {
            "ready_for_pickup_time_secs": 500,
            "source": "PREDICTED_BY_UBER",
            "ready_for_pickup_time": "2016-09-01T10:11:12.123456-0500"
          },
          "completed_time": "2016-09-01T10:11:12.123456-0500",
          "eligible_actions": {
            "adjust_ready_for_pickup_time": {
              "is_eligible": true,
              "reason": "string"
            },
            "mark_out_of_item": {
              "is_eligible": true,
              "reason": "string"
            },
            "cancel": {
              "is_eligible": true,
              "reason": "string"
            },
            "mark_cannot_fulfill": {
              "is_eligible": true,
              "reason": "string"
            },
            "adjust_etd_time": {
              "is_eligible": true,
              "reason": "string"
            },
            "customer_request_etd": {
              "is_eligible": true,
              "reason": "string"
            }
          },
          "failure_info": {
            "reason": "POS_DENIED",
            "failure_attributed_to_party": "UNKNOWN",
            "will_merchant_be_paid": true,
            "description": "string"
          },
          "created_time": "2016-09-01T10:11:12.123456-0500",
          "has_membership_pass": true,
          "retailer_loyalty_info": {
            "loyalty_number": 1240822
          },
          "order_tracking_metadata": {
            "url": "https://earn.sng.link/A3ir4p/eh3s?_dl=uberdriver://byoc-mode?code=fedbab8e-cbce-484e-9d90-067489017968&_smtype=3&pcn=byoc_ot&$deeplink_path=uberdriver://byoc-mode?code=fedbab8e-cbce-484e-9dh0-067489917961"
          }
        }
      }
    ],
    "pagination_data": {
      "next_page_token": "string",
      "page_size": 0
    }
  },
  {
    "data": [
      {
        "order": {
          "id": "bd1ed236-ee79-11ed-a05b-0242ac12A003",
          "display_id": "2A003",
          "external_id": "UBER_EATS_ORDER_1",
          "state": "Accepted",
          "status": "SCHEDULED",
          "preparation_status": "PREPARING",
          "ordering_platform": "UBER_EATS",
          "fulfillment_type": "DELIVERY_BY_UBER",
          "scheduled_order_target_delivery_time_range": {
            "start_time": "2016-09-01T10:11:12.123456-0500",
            "end_time": "2016-09-01T10:11:12.123456-0500"
          },
          "store": {
            "id": "bd1ed236-ee79-11ed-a05b-0242ac120003",
            "name": "Uber's Pizza Palace",
            "partner_identifiers": [
              {
                "id": "store1",
                "type": "MERCHANT_STORE_ID"
              }
            ]
          },
          "customers": [
            {
              "id": "9ae8779e-1cd7-5322-86b6-d7955afd051b",
              "name": {
                "display_name": "Uber L",
                "first_name": "Uber",
                "last_name": "L"
              },
              "order_history": {
                "past_order_count": 3
              },
              "contact": {
                "phone": {
                  "number": "+1-800-999-9999",
                  "pin_code": "888 52 337",
                  "country_iso2": "US"
                }
              },
              "is_primary_customer": true,
              "tax_profile": {
                "tax_ids": "123abc",
                "tax_id_type": "NIF",
                "customer_full_name": "John Smith",
                "email": "john@smith.com",
                "legal_entity_name": "John Smith, LLC",
                "billing_address": "1 Broadway, New York, NY 11109",
                "country": "United States",
                "encrypted_tax_id": {
                  "key": "string",
                  "cipher_text": "string"
                }
              },
              "can_respond_to_fulfillment_issues": true
            }
          ],
          "deliveries": [
            {
              "id": "1676a555-1a6f-4d49-be91-c9bb8f94af49",
              "delivery_partner": {
                "id": "string",
                "name": "John Smith",
                "vehicle": {
                  "type": "CAR",
                  "make": "Honda",
                  "model": "Accord",
                  "color": "red",
                  "license_plate": "T124224",
                  "is_autonomous": true,
                  "handoff_instructions": "string",
                  "passcode": "abc123"
                },
                "picture_url": "string",
                "contact": {
                  "phone": {
                    "number": "+1-800-999-9999",
                    "pin_code": "888 52 337",
                    "country_iso2": "US"
                  }
                },
                "current_location": {
                  "latitude": 38.8951,
                  "longitude": -77.0364
                }
              },
              "status": "SCHEDULED",
              "location": {
                "type": "GOOGLE_PLACE",
                "id": "23119fca-ec44-5c6d-8dc9-2ac8cdde310d",
                "street_address_line_one": "175 Greenwich St",
                "street_address_line_two": "44-023",
                "latitude": "38.8951",
                "longitude": "-77.0364",
                "unit_number": 1,
                "business_name": "Uber Technologies Inc.",
                "city": "NY",
                "country": "US",
                "postal_code": "10007",
                "location_type_value": "asf-123ijfdishs_",
                "client_provided_street_address_line_one": "string"
              },
              "estimated_pick_up_time": "2016-09-01T10:11:12.123456-0500",
              "interaction_type": "DOOR_TO_DOOR",
              "delivery_partner_marked_not_ready_time": "2016-09-01T10:11:12.123456-0500",
              "instructions": "Please do not ring doorbell."
            }
          ],
          "carts": [
            {
              "id": "string",
              "items": [
                {
                  "id": "pizza_cheese",
                  "cart_item_id": "c751e24c-ee7a-11ed-a05b-0242ac120003",
                  "customer_id": "092400ec-ee7b-11ed-a05b-0242ac120003",
                  "title": "Cheese Pizza 18",
                  "external_data": "chz_piz_18",
                  "quantity": {
                    "amount": 1,
                    "in_sellable_unit": {
                      "measurement_unit": {}
                    },
                    "in_priceable_unit": {
                      "measurement_unit": {}
                    }
                  },
                  "default_quantity": {
                    "amount": 1,
                    "unit": "PIECE"
                  },
                  "customer_requests": {
                    "allergy": {
                      "allergens": []
                    },
                    "special_instructions": "Add extra sauce"
                  },
                  "selected_modifier_groups": [
                    {
                      "selected_items": [],
                      "removed_items": []
                    }
                  ],
                  "picture_url": "string",
                  "fulfillment_action": {
                    "action_type": "REPLACE_FOR_ME",
                    "item_substitutes": [
                      null
                    ]
                  }
                }
              ],
              "fulfillment_issues": [
                {
                  "issue_type": "OUT_OF_ITEM",
                  "action_type": "ASK_CUSTOMER",
                  "root_item": {
                    "id": "pizza_cheese",
                    "cart_item_id": "c751e24c-ee7a-11ed-a05b-0242ac120003",
                    "customer_id": "092400ec-ee7b-11ed-a05b-0242ac120003",
                    "title": "Cheese Pizza 18",
                    "quantity": {},
                    "picture_url": "string"
                  },
                  "item_availability": {
                    "items_requested": {},
                    "items_available": {
                      "in_sellable_unit": {},
                      "in_priceable_unit": {}
                    }
                  },
                  "item_substitute": {
                    "id": "pizza_cheese",
                    "quantity": {}
                  },
                  "suspend_until": "2016-09-01T10:11:12.12-0500",
                  "store_response": "The store ran out of stock.",
                  "customer_ack_type": "ACK_DISABLED"
                }
              ],
              "special_instructions": "Please add extra sauce.",
              "include_single_use_items": true,
              "revision_id": "string",
              "restricted_items": {
                "alcohol": {
                  "contain_alcoholic_item": false
                },
                "tobacco": {
                  "contain_tobacco_product": true
                }
              }
            }
          ],
          "payment": {
            "payment_detail": {
              "order_total": {
                "display_amount": "string",
                "net": {
                  "amount_e5": 750000,
                  "currency_code": "LKR",
                  "formatted": "LKR 7.50"
                },
                "tax": {
                  "amount_e5": 0,
                  "currency_code": "LKR",
                  "formatted": "LKR 0.0"
                },
                "gross": {
                  "amount_e5": 750000,
                  "currency_code": "LKR",
                  "formatted": "LKR 7.50"
                },
                "is_tax_inclusive": true
              },
              "item_charges": {
                "total": {
                  "display_amount": "string",
                  "net": {
                    "amount_e5": 750000,
                    "currency_code": "LKR",
                    "formatted": "LKR 7.50"
                  },
                  "tax": {
                    "amount_e5": 0,
                    "currency_code": "LKR",
                    "formatted": "LKR 0"
                  },
                  "gross": {
                    "amount_e5": 750000,
                    "currency_code": "LKR",
                    "formatted": "LKR 7.50"
                  },
                  "is_tax_inclusive": true
                },
                "subtotal_including_promos": {
                  "display_amount": "string",
                  "net": {
                    "amount_e5": 750000,
                    "currency_code": "LKR",
                    "formatted": "LKR 7.50"
                  },
                  "tax": {
                    "amount_e5": 0,
                    "currency_code": "LKR",
                    "formatted": "LKR 0"
                  },
                  "gross": {
                    "amount_e5": 750000,
                    "currency_code": "LKR",
                    "formatted": "LKR 7.50"
                  },
                  "is_tax_inclusive": true
                },
                "price_breakdown": [
                  {
                    "cart_item_id": "c751e24c-ee7a-11ed-a05b-0242ac120003",
                    "price_type": "OPTION",
                    "quantity": {
                      "in_sellable_unit": {},
                      "in_priceable_unit": {}
                    },
                    "total": {
                      "net": {},
                      "tax": {},
                      "gross": {},
                      "is_tax_inclusive": {}
                    },
                    "discount": {
                      "total": {},
                      "quantity": {}
                    },
                    "unit": {
                      "net": {},
                      "tax": {},
                      "gross": {}
                    }
                  }
                ]
              },
              "fees": {
                "total": {
                  "display_amount": "string",
                  "net": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "tax": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "gross": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "is_tax_inclusive": true
                },
                "details": [
                  {
                    "id": "SMALL_ORDER_FEE",
                    "amount": {
                      "net": {},
                      "tax": {},
                      "gross": {}
                    }
                  }
                ]
              },
              "tips": {
                "total": {
                  "display_amount": "string",
                  "net": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "tax": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "gross": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "is_tax_inclusive": true
                }
              },
              "promotions": {
                "total": {
                  "display_amount": "string",
                  "net": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "tax": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "gross": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "is_tax_inclusive": true
                },
                "details": [
                  {
                    "external_promotion_id": "string",
                    "type": "string",
                    "discount_value": "string",
                    "discount_percentage": "string",
                    "discount_delivery_fee_value": 100,
                    "discount_items": [
                      {}
                    ]
                  }
                ],
                "order_total_excluding_promos": {
                  "display_amount": "string",
                  "net": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "tax": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "gross": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "is_tax_inclusive": true
                }
              },
              "adjustment": {
                "total": {
                  "display_amount": "string",
                  "net": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "tax": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "gross": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  },
                  "is_tax_inclusive": true
                },
                "details": {
                  "amount": {
                    "display_amount": "string",
                    "net": {},
                    "tax": {},
                    "gross": {},
                    "is_tax_inclusive": true
                  },
                  "reason": "Customer requested extra meat on salad bowl."
                }
              },
              "currency_code": "string",
              "cash_amount_due": {
                "display_amount": "string",
                "net": {
                  "amount_e5": 750000,
                  "currency_code": "USD",
                  "formatted": "$7.50"
                },
                "tax": {
                  "amount_e5": 750000,
                  "currency_code": "USD",
                  "formatted": "$7.50"
                },
                "gross": {
                  "amount_e5": 750000,
                  "currency_code": "USD",
                  "formatted": "$7.50"
                },
                "is_tax_inclusive": true
              }
            },
            "tax_reporting": {
              "breakdown": {
                "items": [
                  {
                    "instance_id": "string",
                    "description": "DELIVERY_FEE",
                    "gross_amount": {},
                    "net_amount": {}
                  }
                ],
                "fees": [
                  {
                    "instance_id": "string",
                    "description": "DELIVERY_FEE",
                    "gross_amount": {},
                    "net_amount": {}
                  }
                ],
                "promotions": [
                  {
                    "instance_id": "string",
                    "description": "DELIVERY_FEE",
                    "gross_amount": {},
                    "net_amount": {}
                  }
                ]
              },
              "origin": {
                "id": "string",
                "country_iso2": "string",
                "postal_code": "string"
              },
              "destination": {
                "id": "string",
                "country_iso2": "string",
                "postal_code": "string"
              },
              "remittance_info": [
                {
                  "entity": "UBER",
                  "type": "SUBTOTAL",
                  "amount": {
                    "amount_e5": 750000,
                    "currency_code": "USD",
                    "formatted": "$7.50"
                  }
                }
              ]
            }
          },
          "is_order_accuracy_risk": true,
          "store_instructions": "add ketchup",
          "preparation_time": {
            "ready_for_pickup_time_secs": 500,
            "source": "PREDICTED_BY_UBER",
            "ready_for_pickup_time": "2016-09-01T10:11:12.123456-0500"
          },
          "completed_time": "2016-09-01T10:11:12.123456-0500",
          "eligible_actions": {
            "adjust_ready_for_pickup_time": {
              "is_eligible": true,
              "reason": "string"
            },
            "mark_out_of_item": {
              "is_eligible": true,
              "reason": "string"
            },
            "cancel": {
              "is_eligible": true,
              "reason": "string"
            },
            "mark_cannot_fulfill": {
              "is_eligible": true,
              "reason": "string"
            },
            "adjust_etd_time": {
              "is_eligible": true,
              "reason": "string"
            },
            "customer_request_etd": {
              "is_eligible": true,
              "reason": "string"
            }
          },
          "failure_info": {
            "reason": "POS_DENIED",
            "failure_attributed_to_party": "UNKNOWN",
            "will_merchant_be_paid": true,
            "description": "string"
          },
          "created_time": "2016-09-01T10:11:12.123456-0500",
          "has_membership_pass": true,
          "retailer_loyalty_info": {
            "loyalty_number": 1240822
          },
          "order_tracking_metadata": {
            "url": "https://earn.sng.link/A3ir4p/eh3s?_dl=uberdriver://byoc-mode?code=fedbab8e-cbce-484e-9d90-067489017968&_smtype=3&pcn=byoc_ot&$deeplink_path=uberdriver://byoc-mode?code=fedbab8e-cbce-484e-9dh0-067489917961"
          }
        }
      }
    ],
    "pagination_data": {
      "next_page_token": "string",
      "page_size": 0
    }
  }
]
  